export const CommonModelFamiliesValues = ['q3', 'q5', 'q7', 'q8', 'a5'];
